import {Form, Formik, FormikProps, FieldProps, Field} from 'formik'
import * as Yup from 'yup'
import {LoaderButton} from 'app/components/buttons/loader-button/LoaderButton'
import {ITokenTwoFactorCode} from '../interfaces/ITokenTwoFactor'
import {useIntl} from 'react-intl'

interface ITwoFactiorForm {
  tokenHandleSubmit(
    values: ITokenTwoFactorCode,
    {setErrors}: {setErrors: Function}
  ): void
  logoutUserHandler(): void
  isLoading: boolean
}

function TwoFactorCodeForm({
  tokenHandleSubmit,
  logoutUserHandler,
  isLoading,
}: ITwoFactiorForm) {
  const initialValues = {token: ''}
  const intl = useIntl()
  const validationSchema = Yup.object().shape({
    token: Yup.string().matches(/^[0-9]{6}$/, 'MUST_BE_EXACTLY_6_DIGITS'),
  })
  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={tokenHandleSubmit}
      >
        {(formik: FormikProps<ITokenTwoFactorCode>) => (
          <Form className='' noValidate autoComplete='off'>
            <Field name='token'>
              {({field, form, meta}: FieldProps<ITokenTwoFactorCode>) => {
                return (
                  <>
                    <label className='form-label fs-6 fw-bolder text-dark m-4'>
                      Token:
                    </label>
                    <input
                      type='text'
                      id='token'
                      className={`form-control form-control-lg form-control-solid mt-4 ${
                        formik.dirty && meta.error ? `mb-2` : `mb-5`
                      }`}
                      onChange={formik.handleChange}
                      value={formik.values.token}
                    />
                    <span className='text-danger my-0'>
                      {formik.dirty &&
                        meta.error &&
                        intl.formatMessage({
                          id: meta.error,
                        })}
                    </span>

                    <LoaderButton
                      label={intl.formatMessage({id: `CONTINUE`})}
                      buttonType='submit'
                      disabled={!meta.value || !!meta.error}
                      loading={isLoading}
                      classes={`btn-lg btn-primary w-100 ${
                        formik.dirty && meta.error ? `mt-2` : `mt-5`
                      }`}
                    />

                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary w-100 my-5'
                      onClick={() => {
                        logoutUserHandler()
                      }}
                    >
                      {intl.formatMessage({id: `CANCEL`})}
                    </button>
                  </>
                )
              }}
            </Field>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default TwoFactorCodeForm
